import { PharmacyQueryType } from "~/common/types/pharmacies";
import { CreateNewPharmacyFormValuesType } from "~/common/types/pharmacyForm";
import { formatPhoneNumber } from "~/common/utils/formatPhoneNumber";

const emptyPharmacyDefaultValues = {
  pharmacy: {
    name: "",
    phone_number: "",
    address: {
      street: "",
      city: "",
      state: undefined,
      zipcode: "",
    },
  },
  is_default: false,
} as unknown as CreateNewPharmacyFormValuesType;

export const getPharmacyDefaultValues = (
  formData?: PharmacyQueryType,
  options?: { forceDefault?: boolean },
): CreateNewPharmacyFormValuesType =>
  formData
    ? {
        pharmacy: {
          name: formData.pharmacy.name,
          phone_number: formatPhoneNumber(formData.pharmacy.phone_number),
          address: {
            street: formData.pharmacy.address.street,
            city: formData.pharmacy.address.city,
            state: formData.pharmacy.address.state,
            zipcode: formData.pharmacy.address.zipcode.toString(),
          },
        },
        is_default: formData.is_default ?? false,
      }
    : {
        ...emptyPharmacyDefaultValues,
        is_default: options?.forceDefault ?? false,
      };
